import i18next from "i18next"

export const getPlantCountryCode = (plantNumber: string): string =>
	new RegExp(/^[A-Za-z]+/).exec(plantNumber)?.[0].toUpperCase() ?? ""

export const getCountryLabel = (countryCode: string): string =>
	countryCode
		? i18next.t(`shared:country.${countryCode}`, {
				defaultValue: countryCode,
			})
		: ""

export const getPlantCountryLabel = (plantNumber: string): string =>
	getCountryLabel(getPlantCountryCode(plantNumber))
